import productsApi from "@/apis/customerProductApi";

export default {
    namespaced: true,

    state: {
        products: []
    },

    getters: {
        getById: state => id => {
            return state.products.data && state.products.data.find(item => item.id === id);
        }
    },

    mutations: {
        ADD_PRODUCT(state, product) {
            if (state.products.data) {
                state.products.data.unshift(product);
                state.products.meta.to++;
                state.products.meta.total++;
            }
        },
        UPDATE_PRODUCT(state, product) {
            state.products.data = [...state.products.data.map(e => (e.id !== product.id ? e : product))];
        },
        SET_PRODUCTS(state, products) {
            state.products = products;
        },
        DELETE_PRODUCT(state, id) {
            if (state.products.data) {
                state.products.data = state.products.data.filter(item => item.id !== id);
                state.products.meta.to--;
                state.products.meta.total--;
            }
        }
    },

    actions: {
        addProduct({ commit }, data) {
            return productsApi.create(data).then(r => {
                Toast.success("Added successfully");
                commit("ADD_PRODUCT", r.data.data);
            });
        },

        fetchProducts({ commit }, { page = 1, params = {} }) {
            return productsApi.getAll(page, params).then(r => {
                commit("SET_PRODUCTS", r.data);
            });
        },

        fetchProduct({ commit }, id) {
            return productsApi.getById(id).then(r => {
                commit("SET_PRODUCTS", r.data.data);
            });
        },

        fetchProductByCustomerId({ commit }, id) {
            return productsApi.getByCustomerId(id).then(r => {
                commit("SET_PRODUCTS", r.data.data);
            });
        },

        updateProduct({ commit }, product) {
            return productsApi.update(product).then(r => {
                Toast.success("The update was successful");
                window.rrr = r;
                commit("UPDATE_PRODUCT", r.data.data);
            });
        },

        deleteProduct({ commit }, id) {
            return productsApi.delete(id).then(r => {
                Toast.success("Successfully deleted");
                commit("DELETE_PRODUCT", id);
            });
        }
    }
};
